import React, { useState } from 'react';
import { Link } from 'react-router-dom';
import 'antd/dist/antd.css';
import './AccountForm.scss';

import AccountDelimiter from './AccountDelimiter';
import AccountSignLink from './AccountSignLink';
import SignBlock from './SignBlock';
import ErrorField from './ErrorField';

import { useDispatch } from 'react-redux';
import {checkAuthorization, getActiveSubscriptionInfo} from '../reducers/userSlice';

// Common js
import { setCookie, eraseCookie, getCookie} from '../lib/cookies';

//Icons
import {UsernameFromIcon, PasswordFormIcon } from './Icons';

import { Form, Input, Button, Checkbox } from 'antd';
import axios from 'axios';

const layout = {
  labelCol: {
    span: 8,
  },
  wrapperCol: {
    span: 16,
  },
};

const tailLayout = {
  wrapperCol: {
    offset: 8,
    span: 16,
  },
};

export default function AccountForm () {
  const [backError, setBackError] = useState({
    message: 'Unknown Error',
    show: false,
  });
  const dispatch = useDispatch();

  const onFinish = (values) => {
    let formData = new FormData();

    formData.append('userName', values.username);
    formData.append('password', values.password);
    formData.append('rememberMe', values.remember);

    axios.post(`/api/user/login`, formData)
      .then(response => {
        if (response.data.success === true) {
          dispatch(checkAuthorization);
          dispatch(getActiveSubscriptionInfo);
          setCookie('dropUser', 'false', 100, process.env.REACT_APP_BACKLINK_COOCKIE_DOMAIN);
          eraseCookie('dropUser');
          const cookieArray = getCookie('pageFrom').split('>>');
          const lastCookie = cookieArray[cookieArray.length - 1];
          window.location.href = lastCookie;
        } else {
          setBackError({
            message: response.data.message,
            show: true,
          });
        }
      })
      .catch(function (error) {
        setBackError({
          message: error.message,
          show: true,
        });
      });
  };

  const onFinishFailed = (errorInfo) => {
    console.log('Failed:', errorInfo);
  };

  return (
    <Form
      {...layout}
      name='LoginForm'
      initialValues={{
        remember: true,
        username: localStorage.userName,
        password: localStorage.password,
      }}
      onFinish={onFinish}
      onFinishFailed={onFinishFailed}
      className='AccountForm'
    >
      <SignBlock />

      <AccountDelimiter text='or' />

      <Form.Item
        name='username'
        rules={[
          {
            required: true,
            message: 'Please input your username!',
          },
        ]}
      >
        <Input placeholder='Email or Username' prefix={<UsernameFromIcon />} />
      </Form.Item>

      <Form.Item
        // label={<span className='AccountForm__label_withRightLink'>Password <Link to='/restore-password'>Forgot password</Link></span>}
        name='password'
        rules={[
          {
            required: true,
            message: 'Please input your password!',
          },
        ]}
      >
        <Input.Password placeholder='Password' prefix={<PasswordFormIcon />} />
      </Form.Item>

      { backError.show === true &&
        <ErrorField error_message={backError.message} show={backError.show}/>
      }

      <div className='AccountForm__label_withRightLink'>
        <Form.Item className='checkbox' name='remember' valuePropName='checked'>
          <Checkbox>Remember me</Checkbox>
        </Form.Item>

        <Link to='/restore-password'>Forgot password</Link>
      </div>

      <Form.Item {...tailLayout}>
        <Button type='primary' htmlType='submit'>
          Log in
        </Button>
      </Form.Item>

      <AccountSignLink text='Don’t have an account?' linktext='Register' linkroute='/register' />
    </Form>
  );
};


